"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCart = void 0;
const tag_book_sellout_1 = require("@grupoboticario/tag-book-sellout");
const react_1 = require("react");
const providers_1 = require("../providers");
const useCartMenu_1 = require("./useCartMenu");
const useLocalCart_1 = require("./useLocalCart");
const useOnlineCart_1 = require("./useOnlineCart");
/**
 * Hook para consumir e manipular o carrinho de compras
 * Esse hook é apenas uma abstração para futuras implementações de carrinho de compras.
 * @returns {ReturnType<typeof useLocalCart>} Retorna o hook {@link useLocalCart}
 */
function useCart() {
    const context = (0, react_1.useContext)(providers_1.CartContext);
    const { items, strategy, totalItems, state } = context.state;
    const isOnline = strategy === 'online';
    const cartHook = isOnline ? (0, useOnlineCart_1.useOnlineCart)() : (0, useLocalCart_1.useLocalCart)();
    const cartMenu = (0, useCartMenu_1.useCartMenu)();
    const openBag = () => {
        cartMenu.openBag();
        (0, tag_book_sellout_1.ecommerceEvent)({
            eventName: 'view_cart',
            products: items,
        });
    };
    const removeItem = (...parameters) => __awaiter(this, void 0, void 0, function* () {
        cartHook.removeItem(...parameters);
        (0, tag_book_sellout_1.ecommerceEvent)({
            eventName: 'remove_from_cart',
            products: [parameters[0]],
        });
    });
    const placeOrder = (...parameters) => __awaiter(this, void 0, void 0, function* () {
        return yield cartHook.placeOrder(...parameters);
    });
    return Object.assign(Object.assign({ cart: items, totalItems }, cartHook), { removeItem,
        placeOrder, cartMenu: Object.assign(Object.assign({}, cartMenu), { openBag }), isLoading: state === 'loading', isLoaded: state === 'loaded', isIdle: state === 'idle', isError: state === 'error' });
}
exports.useCart = useCart;
